import { useCallback } from 'react'

import { ApiService } from '@services'
import { useDispatcherSounds } from '@shared'
import {
  InventoryCard,
  useAvailableQuests,
  useInventoryActions,
  useMainQuest,
  useKPKStore,
  QuestId,
} from '@store'

export const useCard = () => {
  const { useCard } = useInventoryActions()
  const { setSoundPlaying } = useKPKStore((state) => state)

  const { playSoundRandom } = useDispatcherSounds({
    soundsConfigKey: 'keyUseds',
    onSoundPlay: (key) => {
      setSoundPlaying(key)
    },
    onSoundStop: (_) => {
      setSoundPlaying(null)
    },
  })
  const quests = useAvailableQuests.store.quests()

  const useCardHandler = useCallback(
    (card: InventoryCard, questSlug?: string) => {
      if (card?.title === 'Insight Key') {
        if (questSlug) {
          return useCard(card, { quest_slug: questSlug }).then(async () => {
            if (questSlug === QuestId.KPK) {
              playSoundRandom()
            }
            if (questSlug === QuestId.Lock) {
              await useMainQuest.getState().actions.fetch()
              return true
            }
            await ApiService.poll(
              async () => {
                await useMainQuest.getState().actions.fetch()
                return useMainQuest.getState().solved
              },
              (solved) => solved
            )
          })
        }
      }

      return useCard(card)
    },
    [quests]
  )

  return { useCardHandler }
}
